import React, { useEffect, useState } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "300px",
};

const GOOGLE_MAPS_API_KEY = "AIzaSyAfl3Oh-uGgHqYEydcp4xcaBE5s3H_xSTo"; // 🔐 Replace with your key

const GoogleMapWithMarker = ({
  selectedPlace,
  latitude,
  longitude,
  setLat,
  setLng,
  handleChange,
  selectedIndex
}) => {
  const [markerPosition, setMarkerPosition] = useState(null);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: ["places"],
  });
  // Handles when a new place is selected
  useEffect(() => {
    console.log("selectedPlace--->", selectedPlace);
    if (selectedPlace?.geometry?.location) {
      const newLat = selectedPlace.geometry.location.lat;
      const newLng = selectedPlace.geometry.location.lng;

      setMarkerPosition({ lat: newLat, lng: newLng });
      // setLatitude(newLat);
      // setLongitude(newLng);
    }
  }, [selectedPlace]);

  // Handles pre-filled lat/lng (edit mode)
  useEffect(() => {
    console.log("UseLat--->", latitude);
    if (!selectedPlace && latitude && longitude) {
      setMarkerPosition({
        lat: parseFloat(latitude),
        lng: parseFloat(longitude),
      });
    }
  }, [latitude]);

  console.log("markerPosition--->", markerPosition);

  const handleMarkerDragEnd = (e) => {
    const newLat = e.latLng.lat();
    const newLng = e.latLng.lng();
    setMarkerPosition({ lat: newLat, lng: newLng });
    setLat(newLat);
    setLng(newLng);

    const locationValue = `${newLat}, ${newLng}`;
    handleChange(selectedIndex, "location", locationValue);

    // optional: set to form or state
    // setFieldValue("latitude", newLat);
    // setFieldValue("longitude", newLng);
  };

  if (!isLoaded || !markerPosition) return <div>Loading Map...</div>;

  return (
    <>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={markerPosition}
        zoom={16}
      >
        <Marker
          position={markerPosition}
          draggable
          onDragEnd={handleMarkerDragEnd}
          icon="http://maps.google.com/mapfiles/ms/icons/red-dot.png"
        />
      </GoogleMap>

      {/* <div style={{ marginTop: "10px" }}>
        <strong>Selected Coordinates:</strong>
        <br />
        Latitude: {markerPosition.lat}
        <br />
        Longitude: {markerPosition.lng}
      </div> */}
    </>
  );
};

export default GoogleMapWithMarker;
